import api from './client';

export interface Group {
  id: string;
  organization_id: string;
  name: string;
  description: string;
  permissions: string[];
  member_count: number;
  created_at: string;
  updated_at: string;
}

export const listGroups = async (): Promise<Group[]> => {
  const response = await api.get('/api/groups');
  return response.data.groups || [];
};

export const createGroup = async (data: {
  name: string;
  description: string;
  permissions: string[];
}): Promise<Group> => {
  const response = await api.post('/api/groups', data);
  return response.data.group;
};

export const updateGroup = async (
  id: string,
  data: { name?: string; description?: string; permissions?: string[] }
): Promise<Group> => {
  const response = await api.patch(`/api/groups/${id}`, data);
  return response.data.group;
};

export const deleteGroup = async (id: string): Promise<void> => {
  await api.delete(`/api/groups/${id}`);
};
